import is from '@sindresorhus/is';
import type { FunctionComponent, ReactNode } from 'react';

import { IconInboxEmpty } from '../icons';

type EmptyStateMessageProps = {
    /** Omitted where the surrounding surface already carries the wording and only the mark is wanted. */
    readonly children?: ReactNode;
    readonly icon?: ReactNode;
    readonly placement?: 'center' | 'one-third';
};

export const EmptyStateMessage: FunctionComponent<EmptyStateMessageProps> = ({
    children,
    icon = <IconInboxEmpty size={24} />,
    placement = 'center',
}) => {
    const message = is.nullOrUndefined(children) ? null : (
        <p className="m-0 text-body-xs font-normal leading-[1.125rem]">{children}</p>
    );

    if (placement === 'one-third') {
        return (
            <div
                className="relative h-full min-h-[12rem] w-full text-center text-text-content-faint"
                data-placement={placement}
                data-testid="empty-state-message"
            >
                <div className="absolute left-0 right-0 top-1/3 flex -translate-y-1/2 flex-col items-center gap-m px-xl">
                    {icon}
                    {message}
                </div>
            </div>
        );
    }

    return (
        <div
            className="flex h-full min-h-[6.125rem] w-full flex-col items-center justify-center gap-m py-xl text-center text-text-content-faint"
            data-placement={placement}
            data-testid="empty-state-message"
        >
            {icon}
            {message}
        </div>
    );
};
